import { Injectable } from '@angular/core';
import { delay, forkJoin, Observable, of } from 'rxjs';
import { ApiService } from '../../core/api.service';
import { LogApiService } from './logs.api.service';
import { ShiftLog, ShiftLogDto, ShiftLogPost, ShiftLogPut } from '../../models/shift-log.model';
import { ProgramsStore } from '../stores/programs.store';
import { UsersStore } from '../stores/users.store';
import { ShiftLogTaskFormValue } from '../../components/dialogs/task-dialogs/task.dialog.model';
import { NO_PROGRAM_ID, NO_PROGRAM_LABEL } from '../../shared/constants/program';


@Injectable({ providedIn: 'root' })
export class ShiftLogsService extends LogApiService<ShiftLog, ShiftLogPost, ShiftLogDto> {
  constructor(
    private api: ApiService,
    private programsStore: ProgramsStore,
    private usersStore: UsersStore
  ) {
    super(api, '/shift_logs');
  }

  protected override mapEntity(item: ShiftLogDto): ShiftLog {
    const programName =
      item.program_id === NO_PROGRAM_ID
        ? 'Other'
        : this.programsStore.getNameById(item.program_id) ?? item.program_id ?? 'No Program found';
    const createdByUserName = this.usersStore.getNameById(item.created_by) ?? item.created_by ?? 'No User found'; // fallback if not found

    return {
      id: item.id.toString(),
      activity: item.activity,
      programId: item.program_id,
      programName: programName,
      createdByName: createdByUserName,
      createdById: item.created_by,
      dueDate: new Date(item.date),
      notes: item.notes,
      createdDate: new Date(item.created_dttm),
      timezone: item.timezone,
      updatedDate: item.updated_dttm,
      updatedBy: item.updated_by,
    };
  }

  public override createPayload(formValue: ShiftLogTaskFormValue, userId: string): ShiftLogPost {
    const payload: ShiftLogPost = {
      program_id: formValue.programId || NO_PROGRAM_LABEL,
      activity: formValue.activity!,
      notes: formValue.notes,
      timezone: 'UTC',
      created_by: userId,
      created_dttm: new Date().toISOString(),
    };
    if (formValue.dueDate) {
      payload.date = new Date(formValue.dueDate).toISOString();
    }
    return payload;
  }

  buildUpdatedPayload(log: ShiftLog, userId: string): ShiftLogPut {
    return {
      id: Number(log.id),
      program_id: log.programId || NO_PROGRAM_LABEL,
      notes: log.notes,
      date: new Date(log.dueDate).toISOString(),
      timezone: log.timezone,
      created_by: log.createdById,
      created_dttm: new Date(log.createdDate).toISOString(),
      updated_by: userId,
      updated_dttm: new Date().toISOString(),
      activity: log.activity,
    };
  }
}
